module.exports = __webpack_public_path__ + "Roboto-Light.46e48ce0628835f68a73.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.ttf
// module id = 301
// module chunks = 2